import {
  FormClassApply,
  Prefectures,
  SubsidyApplyKbn,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

const searchFormData: any = [
  {
    label: "申請年度",
    keyword: "year",
    type: "selectFrom",
  },
  {
    label: "都道府県",
    keyword: "prefectureCd",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(Prefectures),
  },
];

const formAreaList = [
  {
    header: "【概算交付】",
    subsidyApplyKbn: SubsidyApplyKbn["概算交付申請"],
    formClass: [
      FormClassApply["都道府県別所要調書一覧（概算交付）"],
      FormClassApply["補助金精算額調書"],
      FormClassApply["補助金所要額調書"],
    ],
  },
  {
    header: "【追加交付】",
    subsidyApplyKbn: SubsidyApplyKbn["追加交付申請"],
    formClass: [
      FormClassApply["補助金所要額調書"],
      FormClassApply["都道府県別所要調書一覧（追加交付）"],
    ],
  },
];

export { searchFormData, formAreaList };
